import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { Button, TranslationFunction } from '../../../components/blocks/localization';

// The review page's Discard, Cancel and Submit actions.

export type PoReviewFooterActionsProps = {
    t: TranslationFunction;
    isSubmitDisabled: boolean;
    isSubmitBusy: boolean;
    isDiscardBusy: boolean;
    onDiscard: () => void;
    onCancel: () => void;
    onSubmit: () => void;
    dataTestIdPrefix: string;
};

const PoReviewFooterActions: FC<PoReviewFooterActionsProps> = ({
    t,
    isSubmitDisabled,
    isSubmitBusy,
    isDiscardBusy,
    onDiscard,
    onCancel,
    onSubmit,
    dataTestIdPrefix,
}) => (
    <Row alignmentHorizontal={'right'}>
        <Button
            type={'tertiary'}
            disabled={isSubmitDisabled || isSubmitBusy}
            isBusy={isDiscardBusy}
            onClick={onDiscard}
            data-testid={`${dataTestIdPrefix}.discardButton`}
        >
            {t('discardPurchaseOrder-buttonLabel')}
        </Button>
        <Button type={'secondary'} onClick={onCancel} data-testid={`${dataTestIdPrefix}.cancelButton`}>
            {t('cancel-buttonLabel')}
        </Button>
        <Button
            type={'primary'}
            disabled={isSubmitDisabled || isDiscardBusy}
            isBusy={isSubmitBusy}
            onClick={onSubmit}
            data-testid={`${dataTestIdPrefix}.submitButton`}
        >
            {t('submitPurchaseOrder-buttonLabel')}
        </Button>
    </Row>
);

export { PoReviewFooterActions };
